import '@/styles/style.scss';
import '@/pages/search/search.scss';

import '@/components/dropdown/dropdown.js';
import '@/components/button-rate/button-rate.js';
import '@/components/bullet-list/bullet-list.js';
import '@/components/template/template.js';
import '@/components/room-card/room-card.js';
import '@/components/range-slider/range-slider.js';
import '@/components/pagination/pagination.js';
